import { ImportTypes } from 'client/components/Screen/ImportScreen/ImportScreen'
import { l } from 'client/Other/Translation'

export const getFieldsForMapping = (type: ImportTypes) => {
  const fields = {
    CUSTOMER: [
      'customerNumber',
      'companyName',
      'firstName',
      'lastName',
      'email',
      'phoneNumberWork',
      'phoneNumberHome',
      'address.streetAddress1',
      'address.streetAddress2',
      'address.pobox',
      'address.city' /* 'address.country', */,
      'paymentTerm',
      'vatNumber',
      'firstNameLastName',
      'poboxCity',
      'cityPobox',
      'title',
      'businessId',
    ],
    PRODUCT: ['name', 'description', 'price', 'total', 'unit', 'vatPct'],
  }
  return fieldsTranslation(fields[type])
}

const fieldsTranslation = (arr: string[]) => {
  const sortArr: { key: string; value: string }[] = []
  for (const key of arr) {
    sortArr.push({ key, value: l(`Import.${key}`) })
  }
  sortArr.sort((a, b) => a.value.localeCompare(b.value))

  const obj: { [key: string]: string } = {
    empty: l('Import.Choose'),
  }
  for (const el of sortArr) {
    obj[el.key] = el.value
  }

  return obj
}
